export default class Repairs {
    static getRepairs() {
        return [
            {
                repair: 'Labour',
                repairDetail: 'Labour',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Courtesy Car',
                repairDetail: 'Courtesy Car',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Insurance Excess Waiver',
                repairDetail: 'Insurance Excess Waiver',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Paint & Materials',
                repairDetail: 'Paint & Materials',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Wheels',
                repairDetail: 'Wheels',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Bonnet',
                repairDetail: 'Bonnet',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Grille',
                repairDetail: 'Grille',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Front Valance',
                repairDetail: 'Front Valance',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Front Bumper',
                repairDetail: 'Front Bumper',
                scratchDent: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Front Wing',
                repairDetail: 'N/S Front Wing',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Mirror',
                repairDetail: 'N/S Mirror',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Roof Pillars',
                repairDetail: 'N/S Roof Pillars',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Roof',
                repairDetail: 'Roof',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Front Door',
                repairDetail: 'N/S Front Door',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Rear Door',
                repairDetail: 'N/S Rear Door',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Qrt. Panel',
                repairDetail: 'N/S Qrt. Panel',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Petrol Cap',
                repairDetail: 'Petrol Cap',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Boot Lid',
                repairDetail: 'Boot Lid',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Tail Gate',
                repairDetail: 'Tail Gate',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Rear Valance',
                repairDetail: 'Rear Valance',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Rear Bumper',
                repairDetail: 'Rear Bumper',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S Qrt. Panel',
                repairDetail: 'O/S Qrt. Panel',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S Rear Door',
                repairDetail: 'O/S Rear Door',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S Front Door',
                repairDetail: 'O/S Front Door',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S Roof Pillars',
                repairDetail: 'O/S Roof Pillars',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S Mirror',
                repairDetail: 'O/S Mirror',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S/F Wing',
                repairDetail: 'O/S/F Wing',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Spoiler',
                repairDetail: 'Spoiler',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'Sills',
                repairDetail: 'Sills',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'O/S Where Marked',
                repairDetail: 'O/S Where Marked',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            },
            {
                repair: 'N/S Where Marked',
                repairDetail: 'N/S Where Marked',
                scratchDent: false,
                blend: false,
                scratch: false,
                chips: false,
                dent: false,
                trim: false,
                osr: false,
                nsr: false,
                osf: false,
                nsf: false,
                identify: '',
                damageCommentsScratchDent: '',
                damageCommentsBlend: '',
                damageCommentsScratch: '',
                damageCommentsChips:'',
                damageCommentsDent: '',
                damageCommentsTrim: '',
                labour: null
            }
        ]
    }
}
